import { Box, Label } from '@workwhile/ui'
import React, { useMemo } from 'react'

type InvoiceStatusProps = {
  status: string
  minWidth?: string
}

export const InvoiceStatus = ({
  status,
  minWidth = '120px',
}: InvoiceStatusProps) => {
  const config = useMemo(() => {
    switch (status) {
      case 'paid':
        return { label: 'Paid', color: 'success' as const }
      case 'pending':
        return { label: 'Pending', color: 'warning' as const }
      case 'created':
        return { label: 'Created', color: 'information' as const }
      case 'failed':
        return { label: 'Failed', color: 'error' as const }
      case 'uncollectible':
        return { label: 'Uncollectible', color: 'none' as const }
      case 'uninvoiced':
        return { label: 'Uninvoiced', color: 'warning' as const }
      default:
        return { label: status, color: 'none' as const }
    }
  }, [status])

  return (
    <Box as="span" minWidth={minWidth}>
      <Label variant={config.color} size="small">
        {config.label}
      </Label>
    </Box>
  )
}
